import React from "react";
import { Link } from "react-router-dom";
import { adatisLogos } from "../../config/branding";

type AdatisLogoVariant = keyof typeof adatisLogos;

const defaultHeights: Record<AdatisLogoVariant, number> = {
  dark: 24,
  light: 24,
  sm: 26,
  menu: 34,
  wellness: 28,
};

export interface AdatisLogoProps {
  variant?: AdatisLogoVariant;
  height?: number;
  className?: string;
  linkTo?: string | false;
  alt?: string;
}

const AdatisLogo = ({
  variant = "dark",
  height,
  className = "",
  linkTo = "/",
  alt = "Adatis",
}: AdatisLogoProps) => {
  const img = (
    <img
      src={adatisLogos[variant]}
      alt={alt}
      height={height ?? defaultHeights[variant]}
      className={className}
    />
  );

  if (linkTo === false) {
    return img;
  }

  return (
    <Link to={linkTo} className={className}>
      {img}
    </Link>
  );
};

export default AdatisLogo;
